import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";














import { PrimaryTimberStorage } from "../../../../timber/types/models/TimberStorage";

import TimberStorageFormSelect from "../../../../timber/components/timberStorage/TimberStorageForm/TimberStorageFormSelect";

import { useGetTimberStorageQuery } from "../../../../timber/apis/TimberStorage.api";



import { PrimaryCutting } from "../../../../timber/types/models/Cutting";
import { useGetCuttingQuery } from "../../../../timber/apis/Cutting.api";
import ContractorUserFormSelect from "../../../../timber/components/contractorUser/ContractorUserForm/ContractorUserFormSelect";



import LocationFormSelect from "../../../../location/components/location/LocationForm/LocationFormSelect";






import BuyerFormSelect from "../../../../timber/components/buyer/BuyerForm/BuyerFormSelect";


















import RoadCarrierFormSelect from "../../../../timber/components/roadCarrier/RoadCarrierForm/RoadCarrierFormSelect";
























import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";
import {useStateSession} from "../../../../hooks/useAuth.ts";
import {useGetContractorUserPresentationQuery} from "../../../apis/ContractorUser.api.ts";
import { useFormContext } from "react-hook-form";












const ContractorUserFormSelect_shippingContractorUserId = ({watch, prefix = ''})  => {

    const [cuttingId,] = watch([
        'cuttingId',
    ])

    const { data: cuttingIdData } = useGetCuttingQuery(PrimaryCutting.fromId(cuttingId), {skip: !cuttingId})

    return (
    <ContractorUserFormSelect
        type="dynamicSelect"
        name="shippingContractorUserId"
        label={t`Shipping Contractor User`}
        prefix={prefix}
        required={ true }
        
        filter={ {contractorIdRefs: cuttingIdData?.contractorId ? [cuttingIdData?.contractorId] : [],
            } }
        
    />
    )
}































export const initialFormStateFn = () => { return {
    
        
        key: "",
        
    
        
        storageId: null,
        
    
        
        shipmentAt: formatDateTimeParam(new Date()),
        
    
        
        shippingContractorUserId: null,
        
    
        
        sourceLocationId: null,
        
    
        
        sourceParcel: "",
        
    
        
        buyerId: null,
        
    
        
        targetAddress: "",
        
    
        
        targetCity: "",
        
    
        
        targetCountry: "",
        
    
        
        state: ShipmentState.Upcoming,
        
    
        
        shipmentType: ShipmentType.Logs,
        
    
        
        roadCarrierId: null,
        
    
        
        truckRegistrationNumber: "",
        
    
        
        truckerName: "",
        
    
        
        workOrder: "",
        
    
        
        shipmentOrder: "",
        
    
        
        forPersonalUse: false,
        
    
        
        description: "",
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.storageId = PrimaryTimberStorage.fromQuery(location.state?.timberStorageId) || null;
    

    const { data: storageIdData } = useGetTimberStorageQuery(PrimaryTimberStorage.fromId(initialFormState.storageId), { skip: !initialFormState.storageId })
    initialFormState.sourceLocationId = initialFormState.sourceLocationId || storageIdData?.locationId || null;
    

    const {userId} = useStateSession()
    const { data: cutting } = useGetCuttingQuery(PrimaryCutting.fromId(location.state?.cuttingId || storageIdData?.cuttingId), {skip: !(location.state?.cuttingId || storageIdData?.cuttingId)})
    const {
        data: contractorUserList,
    } = useGetContractorUserPresentationQuery({
        filter: {
            contractorIdRefs: cutting?.contractorId ? [cutting?.contractorId] : [],
            userIdRefs: [userId],
        }
    })

    initialFormState.shippingContractorUserId = contractorUserList?.items?.length && contractorUserList?.items[0]?.id;

    return React.useMemo(() => initialFormState, [
        location.state,
        storageIdData,
        
        initialFormState.sourceLocationId,
        initialFormState.shippingContractorUserId,
        
    ])
}

export const formObject = {
    
    
        key:
        string()
        .trim()
        .min(1, msg`Key is required`),
    
    
        storageId:
        string()
                .nanoid(msg`Storage is required`)
                .min(1, msg`Storage is required`),
    
    
        shipmentAt:
        string()
        .trim()
        .nullish(),
    
    
        shippingContractorUserId:
        string()
                .nanoid(msg`Shipping Contractor User is required`)
                .min(1, msg`Shipping Contractor User is required`),
    
    
        sourceLocationId:
        string()
                .nanoid(msg`Source Location is required`)
                .nullish(),
    
    
        sourceParcel:
        string()
        .trim()
        .nullish(),
    
    
        buyerId:
        string()
                .nanoid(msg`Buyer is required`)
                .nullish(),
    
    
        targetAddress:
        string()
        .trim()
        .nullish(),
    
    
        targetCity:
        string()
        .trim()
        .nullish(),
    
    
        targetCountry:
        string()
        .trim()
        .nullish(),
    
    
        state:
        string()
        .trim()
        .min(1, msg`State is required`),
    
    
        shipmentType:
        string()
        .trim()
        .min(1, msg`Shipment Type is required`),
    
    
        roadCarrierId:
        string()
                .nanoid(msg`Road Carrier is required`)
                .nullish(),
    
    
        truckRegistrationNumber:
        string()
        .trim()
        .nullish(),
    
    
        truckerName:
        string()
        .trim()
        .nullish(),
    
    
        workOrder:
        string()
        .trim()
        .nullish(),
    
    
        shipmentOrder:
        string()
        .trim()
        .nullish(),
    
    
        forPersonalUse:
        boolean()
        .nullish(),
    
    
        description:
        string()
        .trim()
        .nullish(),
    
};

export const formSchema = object(formObject);
export const closedFormSchema = object({
    ...formObject,
    shipmentAt:
        string()
            .min(1, msg`Shipment at is required`),
    buyerId:
        string()
            .nanoid(msg`Buyer is required`),
    roadCarrierId:
        string()
            .nanoid(msg`Road Carrier is required`),
    truckerName:
        string()
            .min(1, msg`Trucker name at is required`),
    forPersonalUse:
        boolean(),
});

const ShipmentAddForm = ({watch, prefix = ''})  => {

    const { setValue } = useFormContext();

    const onBuyerChange = (buyer: any) => {
        if (buyer?.addressIdAddress) {
            setValue(prefix + 'targetAddress', buyer.addressIdAddress.address || '');
            setValue(prefix + 'targetCity', buyer.addressIdAddress.city || '');
            setValue(prefix + 'targetCountry', buyer.addressIdAddress.country || '');
        }
    }

    const session = useStateSession()
    const canEditContractorUser = session.hasPermission('', 'applications/timber/entities/Shipments/contractorUser/view')

    return (
        <Container>
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'key' }
       aria-label="key"
       data-testid="key"
       label={t`Key`}
       
       type='text'
       
   />
   
   
           
           
   
    
    <TimberStorageFormSelect
        type="dynamicSelect"
        name="storageId"
        label={t`Storage`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
        
           <crudgen.FormDateTime
                
                name={ prefix + 'shipmentAt' }
                aria-label="shipmentAt"
                label={t`Shipment At`}
           />







    { canEditContractorUser
    &&
    <ContractorUserFormSelect_shippingContractorUserId
        watch={watch}
        prefix={prefix}
    />
    }

   
   
           
           
   
    
    <LocationFormSelect
        type="dynamicSelect"
        name="sourceLocationId"
        label={t`Source Location`}
        prefix={prefix}
        required={ false }
    />
   
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'sourceParcel' }
       aria-label="sourceParcel"
       data-testid="sourceParcel"
       label={t`Source Parcel`}
       
       type='text'
       
   />
   
   
           
           
   
    
    <BuyerFormSelect
        type="dynamicSelect"
        name="buyerId"
        label={t`Buyer`}
        prefix={prefix}
        required={ false }
        onValueChange={onBuyerChange}
    />
   
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'targetAddress' }
       aria-label="targetAddress"
       data-testid="targetAddress"
       label={t`Target Address`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'targetCity' }
       aria-label="targetCity"
       data-testid="targetCity"
       label={t`Target City`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'targetCountry' }
       aria-label="targetCountry"
       data-testid="targetCountry"
       label={t`Target Country`}
       
       type='text'
       
   />
   
   
           
           
   
    <crudgen.FormSelect
        required
        name={ prefix + 'state' }
        aria-label="state"
        label={t`State`}
        options={ ShipmentStatePairs }
        optionLabelMap={ toStringShipmentState }
    />
   
   
           
           
   
    <crudgen.FormSelect
        required
        name={ prefix + 'shipmentType' }
        aria-label="shipmentType"
        label={t`Shipment Type`}
        options={ ShipmentTypePairs }
        optionLabelMap={ toStringShipmentType }
    />
   
   
           
           
   
    
    <RoadCarrierFormSelect
        type="dynamicSelect"
        name="roadCarrierId"
        label={t`Road Carrier`}
        prefix={prefix}
        required={ false }
    />
   
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'truckRegistrationNumber' }
       aria-label="truckRegistrationNumber"
       data-testid="truckRegistrationNumber"
       label={t`Truck Registration Number`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'truckerName' }
       aria-label="truckerName"
       data-testid="truckerName"
       label={t`Trucker Name`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'workOrder' }
       aria-label="workOrder"
       data-testid="workOrder"
       label={t`Work Order`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'shipmentOrder' }
       aria-label="shipmentOrder"
       data-testid="shipmentOrder"
       label={t`Shipment Order`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormCheckbox
       
       name={ prefix + 'forPersonalUse' }
       aria-label="forPersonalUse"
       data-testid="forPersonalUse"

       label={t`For Personal Use`}
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'description' }
       aria-label="description"
       data-testid="description"
       label={t`Description`}
       
       type='text'
       
   />
   
   
           
        </Container>
    )
}

export default ShipmentAddForm;
